import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { Issue } from '../issues/components/issue';
import { getCurrentDimensions } from '../shared/hooks/useWindowDimensions';
import { assetPaths } from './assetUtils';
import { Asset } from './components/asset';
import { AssetActivity } from './components/assetActivity';
import { AssetDetail } from './components/assetDetail';
import { AssetDetailFilter } from './components/assetDetailFilter';
import { Assets } from './components/assets';
import { AssetsFilterPage } from './components/assetsFilterPage';
import { EditAsset } from './components/edit';

export const assetsRoutes = [
  {
    path: `${assetPaths.root}/:assetId`,
    element: <Asset />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.all,
    },
    children: [
      {
        path: 'activities/:issueId',
        element: <Issue />,
        loader: () => {
          const dimensions = getCurrentDimensions();
          const maxHeight = (dimensions?.height || 0) - 580;

          return {
            dimensions: dimensions,
            maxHeight: maxHeight,
          };
        },
      },
    ],
  },
  {
    path: assetPaths.root,
    element: <Assets />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.all,
    },
  },
  {
    path: `${assetPaths.root}/filters`,
    element: <AssetsFilterPage />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.all,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/activity/:issueId`,
    element: <AssetActivity />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.all,
    },
  },
  {
    path: 'assets/:assetId/detail',
    element: <AssetDetail />,
    handle: {
      header: {
        titleKey: 'topNav.assetDetail',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.all,
    },
  },
  {
    path: `${assetPaths.root}/:assetId/detail/filters`,
    element: <AssetDetailFilter />,
    handle: {
      header: {
        titleKey: 'assets.menu.title',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.all,
    },
  },
  {
    path: 'assets/:assetId/edit',
    element: <EditAsset />,
    handle: {
      header: {
        titleKey: 'topNav.editAsset',
        icon: 'qrcode',
      },
      requiredPermission: Permissions.asset.all,
    },
  },
];
